var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"icon icon-arrow-left\" ng-if=\"Slider.itemCounts < 3\" ng-click=\"Slider.prevService()\" ng-class=\"{'disabled': Slider.service[0].left == 0}\"></div> <div class=\"services-wrapper\"> <div class=\"block\" ng-repeat=\"item in Services.data\" ng-class=\"{'clearfix': ($index+1) % 4 == 0}\" ui-sref=\"pages.phonepayment({serviceId: item.id})\"> <div class=\"image-block\"> <div class=\"image\"> <img ng-src=\"{{item.icon}}\" alt=\"\"/> </div> </div> <div class=\"text\"> <div class=\"title1\">{{item.name}}</div> </div> </div> <div class=\"clearfix\"></div> </div> <div class=\"icon icon-arrow-right\" ng-if=\"Slider.itemCounts < 3\" ng-click=\"Slider.nextService()\" ng-class=\"{'disabled': Slider.service[3-Slider.itemCounts].left == 0}\"></div>";
ngModule.run(["$templateCache",function(c){c.put("directives/sliderServicesAll/index.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderServicesAll/index.html
 ** module id = 574
 ** module chunks = 1
 **/